<template>
  <button
    class="main_app_button"
    @click="emitClick"
    :type="type"
    :class="{ processing: processing }"
    :disabled="processing"
  >
    <span v-if="!processing">
      <slot></slot>
    </span>
    <div class="loader_ocr" v-if="processing"></div>
  </button>
</template>

<script>
export default {
  name: "AppButton",
  emits: ["emit-click"],
  props: {
    type: {
      type: String,
      required: false,
    },
    processing: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    emitClick() {
      this.$emit("emit-click");
    },
  },
};
</script>

<style lang="scss" scoped>
.main_app_button {
  background-color: $main_color;
  color: $white_color;
  padding: 10px 25px;
  border-radius: 10px;
  border: none;
  min-width: 200px;
  text-transform: capitalize;
  position: relative;
  &:focus {
    box-shadow: none;
  }
  &.cancel {
    background-color: $cancel_color;
    min-width: 100px;
  }
  &.save_modal {
    min-width: 100px;
  }
  &.processing {
    height: 36px;
    cursor: no-drop;
  }
  &.without_data {
    cursor: no-drop;
    opacity: 0.5;
  }
}
.loader_ocr {
  position: absolute;
  width: 25px;
  height: 25px;
  margin-bottom: 7px;
  left: calc(50% - 12.5px);
  top: 15%;
  border: 3px solid #fff;
  border-radius: 50%;
  animation: rotation 0.7s linear infinite;
  border-color: #fff #fff #fff transparent;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
